import { CompanyTravellersCount } from "./types";

export const travelersCountOptions = [
  {
    id: CompanyTravellersCount.ONE,
    value: CompanyTravellersCount.ONE,
    textKey: "AdditionalBenefits.travelersCount-one",
  },
  {
    id: CompanyTravellersCount.BETWEEN_2_AND_5,
    value: CompanyTravellersCount.BETWEEN_2_AND_5,
    textKey: "AdditionalBenefits.travelersCount-between-two-and-five",
  },
  {
    id: CompanyTravellersCount.BETWEEN_6_AND_10,
    value: CompanyTravellersCount.BETWEEN_6_AND_10,
    textKey: "AdditionalBenefits.travelersCount-between-six-and-ten",
  },
  {
    id: CompanyTravellersCount.OVER_10,
    value: CompanyTravellersCount.OVER_10,
    textKey: "AdditionalBenefits.travelersCount-over-ten",
  },
];
